import { useState, useEffect } from 'react';
import type { TokenTheme } from '@/components/TokenCard';

const TOKEN_THEME_KEY = 'vaiu-token-theme';

export const useTokenTheme = () => {
  const [theme, setTheme] = useState<TokenTheme>('default');

  // Load theme from localStorage on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem(TOKEN_THEME_KEY) as TokenTheme;
    if (savedTheme && ['default', 'minimal', 'compact', 'premium'].includes(savedTheme)) {
      setTheme(savedTheme);
    }
  }, []);

  // Save theme to localStorage when it changes
  const updateTheme = (newTheme: TokenTheme) => {
    setTheme(newTheme);
    localStorage.setItem(TOKEN_THEME_KEY, newTheme);
  };

  const getThemeDisplayName = (themeName: TokenTheme): string => {
    switch (themeName) {
      case 'minimal':
        return 'Minimal';
      case 'compact':
        return 'Compact';
      case 'premium':
        return 'Premium';
      default:
        return 'Default';
    }
  };

  const getThemeDescription = (themeName: TokenTheme): string => {
    switch (themeName) {
      case 'minimal':
        return 'Clean and simple design with smaller QR code';
      case 'compact':
        return 'Space-efficient layout for mobile screens';
      case 'premium':
        return 'Elegant design with gradient backgrounds and larger QR code';
      default:
        return 'Balanced design with clear information display';
    }
  };

  const availableThemes: TokenTheme[] = ['default', 'minimal', 'compact', 'premium'];

  return {
    theme,
    setTheme: updateTheme,
    getThemeDisplayName,
    getThemeDescription,
    availableThemes,
  };
};

export default useTokenTheme; 